import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { EnrichedAttributes } from "../../recommendation.types";
import { requestEnrichProduct } from "./enrichProduct.request";

const useEnrichProduct = (
  options?: MutationOptions<
    EnrichedAttributes,
    ApiServiceError<ApiError>,
    string
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestEnrichProduct,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "enrichment"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useEnrichProduct;
